import React from 'react';
import { AuthorMeeting } from './AuthorMeeting';
import AuthorMeetingList from './AuthorMeetingList';

export const AuthorMeetingPage = ()=>{

    return (
        <div className="subpage">
            <div className="meeting_writer">
                <div className="meeting_container">
                    <AuthorMeeting />
                </div>
                <AuthorMeetingList />
            </div>
        </div>
    );
};